import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { paymentApiGateway } from "../../serviceHandler";

const PaymentResult = () => {
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "failed"
  const location = useLocation();

  useEffect(() => {
    // Extract checkoutId from query string
    const params = new URLSearchParams(location.search);
    const checkoutId = params.get("id"); // HyperPay usually appends ?id=...

    if (!checkoutId) {
      setStatus("failed");
      return;
    }

    const verifyPayment = async () => {
      try {
        // const response = await paymentApiGateway.get(
        //   `/hyperpay/v1/payments/${checkoutId}/entityId={8a8294174d0595bb014d05d829cb01cd}`
        // );
        // const resultCode = response.data?.result?.code;

        // if (resultCode && resultCode.startsWith("000.000")) {
        //   setStatus("success");
        // } 
        // else if (resultCode && resultCode.startsWith("000.200.000")) {
        //   setStatus("loading");
        // } 
        // else {
        //   setStatus("failed");
        // }
        setTimeout(() => { setStatus("success");}, 2000); // Simulate network delay
      } catch (err) {
        console.error("Payment verification failed:", err);
        // setStatus("failed");
         setTimeout(() => { setStatus("success");}, 2000)
      }
    };

    verifyPayment();
  }, [location]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      {status === "loading" && (
        <h2 className="text-xl font-bold text-gray-700">Verifying your payment...</h2>
      )}

      {status === "success" && (
        <div className="text-center">
          <h2 className="text-2xl font-bold text-green-600">✅ Payment Successful</h2>
          <p className="mt-2 text-gray-700">Thank you for your purchase!</p>
        </div>
      )}

      {status === "failed" && (
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600">❌ Payment Failed</h2>
          <p className="mt-2 text-gray-700">
            Unfortunately, we couldn’t process your payment. Please try again.
          </p>
        </div>
      )}
    </div>
  );
};

export default PaymentResult;
